import { SourceTableTypeDtoModel } from "./SourceTableTypeDtoModel";
import { IconModel } from "Core/Controls/BaseControl/Models/IconModel";

export class SourceTableDtoModel {
	Id: number;
	Name: string;
	TranslatedName: string;
	Icon: IconModel;
	Types: SourceTableTypeDtoModel[];
}